import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";

const steps = [
  { number: "01", title: "See clearly", description: "We map your current visibility, reputation, and growth gaps." },
  { number: "02", title: "Prioritize", description: "Together, we identify which opportunities to tackle first based on what could make the biggest difference." },
  { number: "03", title: "Take action", description: "Choose the improvements that matter most. RankTrust puts the right solutions to work." },
];

export default function BoltHowItWorks() {
  return (
    <section id="how-it-works" aria-labelledby="how-it-works-title" className="bg-white text-[#10213D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        <div>
          <p className="text-[#245DDF] font-bold uppercase tracking-[0.18em] text-xs mb-6">A smarter starting point</p>
          <h2 id="how-it-works-title" className="text-5xl md:text-6xl font-black tracking-tight leading-[1.05] mb-7">
            Clarity first.<br /><span className="text-[#245DDF]">Growth next.</span>
          </h2>
          <p className="text-lg leading-relaxed text-slate-600 max-w-lg mb-9">
            We uncover where your business may be missing customers and growth opportunities, so you know what deserves your attention.
          </p>
          <a href="https://calendly.com/intentbrain/ranktrust-io" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#245DDF] hover:bg-[#1945AA] text-white px-7 py-4 font-semibold rounded-md transition-colors">
            Book My Growth Assessment <ArrowRight size={19} aria-hidden="true" />
          </a>
        </div>
        <div className="divide-y divide-slate-200 border-y border-slate-200">
          {steps.map(step => (
            <div key={step.number} className="grid grid-cols-[3rem_1fr_auto] gap-5 py-7 items-start">
              <span className="text-[#245DDF] font-bold text-sm pt-1">{step.number}</span>
              <div>
                <h3 className="font-bold text-2xl mb-2">{step.title}</h3>
                <p className="text-slate-600 leading-relaxed">{step.description}</p>
              </div>
              <ArrowUpRight className="text-[#245DDF] mt-1" size={20} aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
